import { DateFormatPatterns, Timezone } from '@clearverify/constants';
import { Nullable } from '@clearverify/types';
import { formatDate, getDateTimeInTimezone } from '@clearverify/utils';

import { DataDisputeReportInfoFragment } from 'src/api';
import { TableColumn } from 'src/components/table';

import {
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_EMAIL_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_EMPLOYERS_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_PEO_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_STATUS_COLUMN,
} from './constants';

export const getDataDisputeReportTableColumnsCVStaff = (timezone: Nullable<Timezone>) => [
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_COLUMN,
  getDataDisputeReportTableCreationDateColumn(timezone),
  DATA_DISPUTE_REPORT_TABLE_EMPLOYERS_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_STATUS_COLUMN,
];

export const getDataDisputeReportTableColumnsEmployerStaff = (timezone: Nullable<Timezone>) => [
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_EMAIL_COLUMN,
  getDataDisputeReportTableCreationDateColumn(timezone),
  DATA_DISPUTE_REPORT_TABLE_STATUS_COLUMN,
];

export const getDataDisputeReportTableColumnsPEOStaff = (timezone: Nullable<Timezone>) => [
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_EMPLOYERS_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_EMAIL_COLUMN,
  getDataDisputeReportTableCreationDateColumn(timezone),
  DATA_DISPUTE_REPORT_TABLE_STATUS_COLUMN,
];

export const getDataDisputeReportTableColumnsPeoPayrollProviderStaff = (
  timezone: Nullable<Timezone>,
) => [
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_PEO_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_EMPLOYERS_COLUMN,
  DATA_DISPUTE_REPORT_TABLE_CONSUMER_EMAIL_COLUMN,
  getDataDisputeReportTableCreationDateColumn(timezone),
  DATA_DISPUTE_REPORT_TABLE_STATUS_COLUMN,
];

const getDataDisputeReportTableCreationDateColumn = (
  timezone: Nullable<Timezone>,
): TableColumn<DataDisputeReportInfoFragment> => ({
  title: 'Creation Date',
  key: 'createdAt',
  sortable: true,
  nonNullSortable: true,
  render: (_valueByDataPath, dataDisputeReport) =>
    formatDate(
      getDateTimeInTimezone(dataDisputeReport.createdAt, timezone)?.toISO(),
      DateFormatPatterns.shortDateWithSlash,
    ),
});
